import { ArrowLeftIcon } from "@primer/octicons-react";
import { Box, Checkbox, FormControl } from "@primer/react";
import moment from "moment";
import { useEffect, useMemo, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import { meetingApi } from "../../api/meetingApi";
import MyHtmlEditor from "../../components/html-editor";
import SccopeSelectionButtonByLop from "../../components/scope-selection-button/SccopeSelectionButtonByLop";
import Button from "../../components/ui/button";
import Text from "../../components/ui/text";
import TextInput from "../../components/ui/text-input";
import { NotifyHelper } from "../../helpers/toast";
import { useCommonSelectedHook } from "../../hooks/useCommonSelectedHook";
import { IMeetingVm } from "../../models/response/meeting/IMeetingVm";
import MeetingSchedule from "./MeetingSchedule";


const MeetingDetail = () => {
    const { id: pId }: any = useParams();
    const id: number = parseInt(pId);
    const navigate = useNavigate();
    const { nam_hoc } = useCommonSelectedHook();
    const fake: any = {};
    const [meeting, setMeeting] = useState<IMeetingVm>(fake);
    const [htmlDescription, setHtmlDescription] = useState("");

    const { register, handleSubmit, reset, clearErrors, setError, formState: { errors }, control } = useForm<IMeetingVm>({
        mode: "all"
    })
    const lopIdsSelected = useMemo(() => {
        return meeting?.scopes?.map(x => x.dm_lop_id) ?? [];
    }, [meeting])

    useEffect(() => {
        handleGetDataAsync();
    }, [id])

    const handleGetDataAsync = async () => {
        const res = await meetingApi.selectDetail(id);
        if (res.is_success) {
            setMeeting(res.data)
            reset({
                ...res.data,
                registration_end_at: res.data?.registration_end_at ? moment(res.data?.registration_end_at).format("YYYY-MM-DD HH:mm") : undefined,
                registration_start_at: res.data?.registration_start_at ? moment(res.data?.registration_start_at).format("YYYY-MM-DD HH:mm") : undefined,
                event_time: res.data?.event_time ? moment(res.data?.event_time).format("YYYY-MM-DD HH:mm") : undefined,
            })
            setHtmlDescription(res.data?.description ?? "")
        }
    }

    const onSubmit = async (data: any) => {
        let isValid = true;
        if ((meeting?.scopes ?? []).filter(x => x.dm_lop_id > 0).length <= 0) {
            isValid = false;
            setError("scopes", {});
        }
        if ((meeting?.slots ?? []).length <= 0) {
            isValid = false;
            setError("slots", {});
        }

        if (!isValid) return;

        const res = await meetingApi.saveChange({
            ...meeting,
            school_year: nam_hoc,
            ...data,
            scopes: meeting.scopes,
            slots: meeting.slots,
            description: htmlDescription,
            is_published: meeting?.is_published ?? false,
            is_allow_re_submit: meeting?.is_allow_re_submit ?? false,
            id: id,
        })
        if (res.is_success) {
            NotifyHelper.Success("Success");
            navigate(`../../meeting/${res.data}`, { replace: true });
        } else {
            NotifyHelper.Error(res.message ?? "Error");
        }


    }

    return (
        <Box sx={{
            // position: "relative",
            // minHeight: "100%",
        }}>
            <form onSubmit={handleSubmit(onSubmit)}>
                <Box sx={{
                    display: "flex",
                    alignItems: "center",
                    backgroundColor: "#F5F8FA",
                    borderBottomColor: "border.default",
                    borderBottomStyle: "solid",
                    p: 3,
                    borderBottomWidth: "1px"
                }}>
                    <Button text="Back" size="medium" variant="invisible" leadingVisual={ArrowLeftIcon}
                        onClick={() => {
                            navigate(-1);
                        }}
                    />
                    <Box sx={{
                        flex: 1,
                        textAlign: "center",
                        whiteSpace: "break-spaces",
                        fontWeight: 600,
                        fontSize: "16px"
                    }}>
                        {meeting?.name ?? "Unknow"}
                    </Box>
                    <Button text="Cập nhật" variant="primary" sx={{ ml: 2 }} size="medium" type="submit" />
                </Box>
                <Box sx={{
                    p: 3,
                    display: "flex",
                    overflowY: "auto",
                    height: window.innerHeight - 150,
                }}>

                    <Box id="center" sx={{
                        flex: 1,
                        display: "flex"
                    }}>
                        <Box
                            display={"grid"}
                            sx={{
                                gap: 2,
                                flex: 1,
                                pl: 3
                            }}
                        >
                            <Box
                                display={"grid"}
                                sx={{
                                    gap: 2
                                }}
                            >
                                <Box id="genaral" sx={{ mb: 3 }}>
                                    <Box sx={{
                                        borderBottom: "1px solid",
                                        borderBottomColor: "border.default",
                                        mb: 3,
                                        pb: 1
                                    }}>
                                        <Text text="Thông tin cơ bản" sx={{ fontSize: 24, fontWeight: "600" }} />
                                    </Box>
                                    <Box
                                        display={"grid"}
                                        sx={{
                                            gap: 2
                                        }}
                                    >
                                        <FormControl>
                                            <FormControl.Label>
                                                Tên cuộc họp
                                            </FormControl.Label>
                                            <TextInput
                                                width={500}
                                                register={register}
                                                required
                                                validateMessage='Vui lòng điền Tên cuộc họp'
                                                name="name"
                                                errors={errors}
                                            />
                                        </FormControl>
                                        <FormControl>
                                            <FormControl.Label>
                                                Tên cuộc họp (tiếng anh)
                                            </FormControl.Label>
                                            <TextInput
                                                width={500}
                                                register={register}
                                                required
                                                validateMessage='Vui lòng điền Tên cuộc họp (Tiếng anh)'
                                                name="name_en"
                                                errors={errors}
                                            />
                                        </FormControl>
                                        <FormControl>
                                            <FormControl.Label>
                                                Thời gian diễn ra
                                            </FormControl.Label>
                                            <Controller
                                                name="event_time"
                                                control={control}
                                                render={({ field }) => (
                                                    <TextInput
                                                        {...field}
                                                        type="datetime-local"
                                                        onChange={(e) => {
                                                            field.onChange(e);
                                                            setMeeting(prev => ({
                                                                ...prev,
                                                                event_time: e.target.value
                                                            }));
                                                        }}
                                                    />
                                                )}
                                            />
                                        </FormControl>
                                    </Box>

                                </Box>
                                <Box id="schedule" sx={{ mb: 3 }}>
                                    <Box sx={{
                                        borderBottom: "1px solid",
                                        borderBottomColor: "border.default",
                                        mb: 3,
                                        pb: 1
                                    }}>
                                        <Text text="Khung giờ" sx={{ fontSize: 24, fontWeight: "600" }} />
                                    </Box>
                                    <Box
                                        display={"grid"}
                                        sx={{
                                            gap: 2
                                        }}
                                    >
                                        <Box>
                                            <FormControl.Caption>
                                                Phụ huynh sẽ đăng ký vào 1 trong các lịch mà bạn tạo theo danh sách bên dưới
                                            </FormControl.Caption>
                                        </Box>
                                        <Box sx={{
                                            borderRadius: 2,
                                            p: 0
                                        }}>
                                            <FormControl sx={{ mt: 2, mb: 2 }}>
                                                {meeting?.event_time &&
                                                    <MeetingSchedule
                                                        setMeeting={setMeeting}
                                                        meeting={meeting}
                                                        errors={errors}
                                                    />
                                                }
                                            </FormControl>
                                        </Box>

                                    </Box>
                                </Box>
                                <Box id="scopes" sx={{ mb: 3 }}>
                                    <Box sx={{
                                        borderBottom: "1px solid",
                                        borderBottomColor: "border.default",
                                        mb: 3,
                                        pb: 1
                                    }}>
                                        <Text text="Phạm vi đăng ký" sx={{ fontSize: 24, fontWeight: "600" }} />
                                    </Box>
                                    <Box
                                        display={"grid"}
                                        sx={{
                                            gap: 2,
                                            width: "500px"
                                        }}
                                    >
                                        <Box>
                                            <FormControl.Caption>
                                                Chỉ các lớp trong phạm vi được chọn và trong thời gian đăng ký có thể đăng ký meeting này.
                                            </FormControl.Caption>
                                        </Box>
                                        <FormControl>
                                            <FormControl.Label>
                                                Lớp đăng ký
                                            </FormControl.Label>
                                            <Box sx={{
                                                width: "100%"
                                            }}>
                                                <SccopeSelectionButtonByLop
                                                    lopIdsSelected={lopIdsSelected}
                                                    onValueChanged={(ids: number[]) => {

                                                        setMeeting({
                                                            ...meeting,
                                                            scopes: ids.map(lopId => {
                                                                return {
                                                                    id: 0,
                                                                    sis_meeting_id: id,
                                                                    dm_lop_id: lopId
                                                                }
                                                            })
                                                        })
                                                        if (ids.length > 0) {
                                                            clearErrors("scopes")
                                                        }
                                                    }}
                                                />
                                            </Box>

                                            {
                                                errors && errors["scopes"] &&
                                                <FormControl.Validation id={"scopes"} variant="error">
                                                    Vui lòng điền phạm vi đăng ký
                                                </FormControl.Validation>
                                            }


                                        </FormControl>

                                        <Box sx={{
                                            display: "grid",
                                            gridTemplateColumns: "1fr 1fr"
                                        }}>
                                            <FormControl>
                                                <FormControl.Label>
                                                    Đăng ký từ ngày
                                                </FormControl.Label>
                                                <TextInput
                                                    name="registration_start_at"
                                                    type="datetime-local"
                                                    register={register}
                                                    required
                                                    block
                                                    validateMessage='Vui lòng điền thời gian bắt đầu đăng ký'
                                                    errors={errors}
                                                />
                                            </FormControl>
                                            <FormControl sx={{ ml: 2 }}>
                                                <FormControl.Label>
                                                    Đăng ký đến ngày
                                                </FormControl.Label>
                                                <TextInput
                                                    name="registration_end_at"
                                                    type="datetime-local"
                                                    register={register}
                                                    required
                                                    block
                                                    validateMessage='Vui lòng điền thời gian kết thúc đăng ký'
                                                    errors={errors}
                                                />
                                            </FormControl>
                                        </Box>
                                        <FormControl sx={{ mt: 2 }}>
                                            <FormControl.Label>
                                                Publish
                                            </FormControl.Label>
                                            <FormControl.Caption sx={{ ml: -4 }}>
                                                Sau khi Published, PHHS có thể nhìn thấy và đăng ký Meeting
                                            </FormControl.Caption>
                                            <Checkbox checked={meeting?.is_published ?? false}
                                                onChange={(e) => {
                                                    setMeeting({
                                                        ...meeting,
                                                        is_published: e.target.checked
                                                    })
                                                }}
                                            />
                                        </FormControl>
                                        <FormControl sx={{ mt: 2 }}>
                                            <FormControl.Label>
                                                Cho phép đăng ký lại
                                            </FormControl.Label>
                                            <FormControl.Caption sx={{ ml: -4 }}>
                                                PHHS có thể sửa lại bản đăng ký
                                            </FormControl.Caption>
                                            <Checkbox checked={meeting?.is_allow_re_submit ?? false}
                                                onChange={(e) => {
                                                    setMeeting({
                                                        ...meeting,
                                                        is_allow_re_submit: e.target.checked
                                                    })
                                                }}
                                            />
                                        </FormControl>
                                    </Box>
                                </Box>
                                <Box id="cover" sx={{ mb: 3 }}>
                                    <Box sx={{
                                        borderBottom: "1px solid",
                                        borderBottomColor: "border.default",
                                        mb: 3,
                                        pb: 1
                                    }}>
                                        <Text text="Thông tin bổ sung" sx={{ fontSize: 24, fontWeight: "600" }} />
                                    </Box>
                                    <Box
                                        display={"grid"}
                                        sx={{
                                            gap: 2
                                        }}
                                    >
                                        <FormControl>
                                            <FormControl.Label>
                                                Địa điểm
                                            </FormControl.Label>
                                            <TextInput
                                                width={500}
                                                register={register}
                                                required
                                                validateMessage='Vui lòng điền địa điểm'
                                                name="location"
                                                errors={errors}
                                            />
                                        </FormControl>
                                        <FormControl>
                                            <FormControl.Label>
                                                Thành phần tham gia
                                            </FormControl.Label>
                                            <TextInput
                                                width={500}
                                                register={register}
                                                required
                                                validateMessage='Vui lòng điền thành phần tham gia'
                                                name="participants"
                                                errors={errors}
                                            />
                                        </FormControl>
                                        <FormControl>
                                            <FormControl.Label>
                                                Mô tả
                                            </FormControl.Label>
                                            <MyHtmlEditor
                                                value={meeting?.description ?? ""}
                                                onValueChanged={(htmlValue) => {
                                                    setHtmlDescription(htmlValue)
                                                }}
                                            />

                                        </FormControl>
                                    </Box>
                                </Box>
                            </Box>
                        </Box>
                    </Box>
                </Box>
            </form>
        </Box>
    );
};

export default MeetingDetail;